// extracted by mini-css-extract-plugin
module.exports = {"image":"ImageModal_image__27Q8h","modal":"ImageModal_modal__3r_DC"};